import { z } from "zod";
/** One card from the card catalog (TCGdex). English cards for now; other languages come later. */
export const CatalogCardSchema = z.object({
    /** Catalog id, e.g. "xyp-XY28". */
    id: z.string().min(1).max(64),
    name: z.string().min(1),
    /** Number as printed on the card: "XY28", "4/102". */
    number: z.string().min(1),
    /** Number within its set, without the set total: "XY28", "4". */
    localId: z.string().min(1),
    setId: z.string().min(1),
    setName: z.string().min(1),
    language: z.literal("en"),
    imageSmall: z.url().nullable(),
    imageLarge: z.url().nullable(),
});
/** GET /api/v1/catalog/cards?q=… — e.g. "venusaur ex xy28" or "charizard 4/102". */
export const CatalogSearchQuerySchema = z.object({
    q: z.string().trim().min(2, "Type at least 2 characters").max(100, "Search is too long"),
});
export const CatalogSearchResponseSchema = z.object({
    data: z.array(CatalogCardSchema),
});
//# sourceMappingURL=catalog.js.map